var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('router-view'),_c('vue-progress-bar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }